import request from "superagent";
import { getAuthHeader } from "src/utils/superagent";
import { uploadFacilityImageFss } from "src/utils/fileUpload";

export enum PhotoStatus {
  DONE = "done",
  UPLOADING = "uploading",
  REMOVED = "removed",
}

export const removeAspectRatio = (url) => {
  const index = url.indexOf("/ar_1.33333333,c_crop");
  const index2 = url.indexOf("/v");
  if (!index || index < 0) {
    return url;
  }
  if (!index2 || index2 < 0) {
    return url;
  }
  return url.substring(0, index) + url.substring(index2, url.length);
};

const transformPhotosListData = (photosList) => {
  photosList.forEach((ph) => {
    ph.uid = `${ph.index}`;
    ph.name = ph.name || ph.url.substring(ph.url.lastIndexOf("/") + 1);
    ph.status = PhotoStatus.DONE;
  });
};

export const getFacilityPhotos = async ({ facilityId }) => {
  const resp = await request
    .get(`${global.api}/facilityProfile/photos/${facilityId}`)
    .set(await getAuthHeader());

  let photosList = [];
  if (resp.body?.photosList) {
    photosList = resp.body.photosList;
    transformPhotosListData(photosList);
  }
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  photosList.sort((a: any, b: any) => {
    if (a.index < b.index) {
      return -1;
    }
    if (a.index > b.index) {
      return 1;
    }
    return 0;
  });
  return photosList;
};

export const uploadFacilityImage = async (facilityId, filteredNewPhotos) => {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fileUploadList: any[] = [];

  for (const photo of filteredNewPhotos) {
    const body = await uploadFacilityImageFss(facilityId, photo.originFileObj);

    photo.fileStorageRootFolder = body.folderName;
    photo.fileStorageFileKey = body.fileKey;
    fileUploadList.push(photo);
  }

  return fileUploadList;
};

export const writeReferenceToFacilityImage = async ({
  facilityId,
  updatedReference,
  filesToDelete,
}): Promise<void> => {
  await request
    .put(`${global.api}/facilityProfile/photos/${facilityId}`)
    .set(await getAuthHeader())
    .send({ updatedReference, filesToDelete });
};
